
import ModalEducateUsers from '@marketplace/components/modals/modal-educate-users.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'ModalWholesaleTerms',

    components: {
        ModalEducateUsers,
    },

    data() {
        return {
            steps: [],
        }
    },

    computed: {
        ...mapGetters('global', ['globalFreeShippingAmount']),

        getGlobalFreeShippingAmount() {
            return this.globalFreeShippingAmount
        },
    },

    created() {
        this.steps = [
            {
                title: `${this.$t('labels.minimum-order-title')}`,
                description: this.$t('labels.minimum-order-description'),
                backgroundColor: '#984F35',
                imageUrl:
                    require('~assets/images/user-education/wholesale-term-modal-image-01.svg'),
            },
            {
                title: this.$t('labels.boost-margins-title'),
                description: this.globalFreeShippingAmount
                    ? this.$t('labels.boost-margins-description', [
                          this.$n(
                              this.globalFreeShippingAmount,
                              'currency-no-decimal'
                          ),
                      ])
                    : this.$t(
                          'labels.boost-margins-description-no-freeshiping'
                      ),
                backgroundColor: '#984F35',
                imageUrl:
                    require('~assets/images/user-education/wholesale-term-modal-image-02.svg'),
            },
            {
                title: this.$t('labels.buy-now-pay-later'),
                description: this.$t('labels.buy-now-pay-later-description'),
                backgroundColor: '#984F35',
                imageUrl:
                    require('~assets/images/user-education/wholesale-term-modal-image-03.svg'),
            },
            {
                title: this.$t('labels.dropshipping_education_title'),
                description: this.$t(
                    'labels.dropshipping_education_description'
                ),
                backgroundColor: '#984F35',
                imageUrl:
                    require('~assets/images/user-education/wholesale-term-modal-image-06.svg'),
            },
        ]
    },
}
